module.exports = __webpack_public_path__ + "img/framework.png.b1270ebb.svg";